import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { ProductGroup } from 'src/app/Models/product';
import { TransactionService } from 'src/app/Services/transaction.service';
import { Utility } from 'src/app/Utilities/utility';
import { ConfirmationDialogComponent } from '../../masters/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-upload-consumable-target',
  templateUrl: './upload-consumable-target.component.html',
  styleUrls: ['./upload-consumable-target.component.css']
})
export class UploadConsumableTargetComponent implements OnInit {

  public Fiscals:any[]=[];
  public Fiscal:string;
  public FiscalNo:number;
  private utility: Utility;
  public ProductGroupList:Array<ProductGroup>=new Array<ProductGroup>();
  public SelectedGroupId:string = "1";
  @ViewChild('file') myfileVariable:any;
  selectedPPFileName:string; //Added by rahul yadav on 27/05/2021 
  showSpinner:boolean=false
  Enable:boolean = false;
  constructor(
          private _TransactionService:TransactionService
        ,private _CookieService: CookieService
        ,private dialog: MatDialog) 
    { 
      this.BindProductGroupList()
      this.Fiscal = "";
      this.FiscalNo = 0;
      this.utility = new Utility(this._CookieService);
      this.selectedPPFileName = "Choose file";
  }
BindProductGroupList(){
  this.ProductGroupList = new Array<ProductGroup>();    
  let _ProductGroup:ProductGroup = new ProductGroup();
  _ProductGroup.ProductGroupId = 1;
  _ProductGroup.ProductGroupDesc = "FINISHED GOODS"
  this.ProductGroupList.push(_ProductGroup);
  _ProductGroup = new ProductGroup();
  _ProductGroup.ProductGroupId = 4;
  _ProductGroup.ProductGroupDesc = "CONSUMABLES"
  this.ProductGroupList.push(_ProductGroup);
}

  ngOnInit(): void {    
    this.BindFiscal();
  }

  BindFiscal(){
    this._TransactionService.GetFiscalForSPRA().subscribe((d:any)=>{
      if(d){
        
        this.Fiscals = JSON.parse(d);
        this.Fiscal = this.Fiscals[2].Fiscal;
      }
    });
  }

  DownloadConsumableTarget(){
    this.FiscalNo = this.Fiscals.filter((f)=> f.Fiscal==this.Fiscal)[0].SequesnceNo;
    this.showSpinner = true;
   
    this._TransactionService.DownloadConsumableTarget(this.FiscalNo,parseInt(this.SelectedGroupId)).subscribe((d)=>{
      if(d){
        this.utility.downloadExcel(d);
        this.showSpinner = false;
       
      }
    });


  }
  changePP(event:any){   //Added by rahul yadav on 27/05/2021 
    if(event){
      if(event.target.files.length >0){
        this.selectedPPFileName = event.target.files[0].name;
      }
    }
  }


  UploadConsumableTarget(files:any) {


    if (files.length === 0){
      alert('Please choose a file to upload!')
      return;
    }

    let _ProductGroupDesc:string = this.ProductGroupList.filter((pgl)=>{
      return pgl.ProductGroupId == parseInt(this.SelectedGroupId)
    })[0].ProductGroupDesc;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '50%',
      data: {
        "Title": "Confirmation",
        "Message": ("Are you sure ! You are uploading " + _ProductGroupDesc +  " target.")
      }
    });
    dialogRef.afterClosed().subscribe((result):any => {
      if (result) {
        if (result.data.IsConfirmed) {
              this.UploadTarget(files);

        }
      }
    });


  
       
          
  }



UploadTarget(files:any){

  const formData = new FormData();
  
  let fileToUpload = <File>files[0];
  var filetype=fileToUpload.type;
   
   if(filetype!='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
     alert('Please Upload .xlsx or .xls file');
     this.myfileVariable.nativeElement.value = ""; //Added by rahul yadav on 27/05/2021 
     this.selectedPPFileName = "";
     this.selectedPPFileName = "Choose file";
     return;
   }
   formData.append('file', fileToUpload, fileToUpload.name);
   formData.append('EnteredBy', this.utility.user.employeeId.toString());
   formData.append('ProductGroupId', this.SelectedGroupId.toString());
   this.showSpinner = true;
   this.Enable=true;
   this._TransactionService.UploadConsumableTarget(formData).subscribe((event: any) => {

   var dataView = new DataView(event);
   var decoder = new TextDecoder('utf8');
   var decodedString = decoder.decode(dataView);
   if(decodedString=="1"){
    this.showSpinner = false;
    this.Enable =false;
    alert('uploaded successfully!!');
  }
  else{
    this.utility.downloadExcel(event);
   alert('uploaded successfully!!');
  }
  this.selectedPPFileName = ""; //Added by rahul yadav on 27/05/2021 
  this.selectedPPFileName = "Choose file";
  this.myfileVariable.nativeElement.value = "";
  });


}


}
